const LEGACY_FIRMWARE_FONT_FAMILIES = new Set([
  'theme_small',
  'theme_normal',
  'theme_subtitle',
  'theme_title',
  'icons',
])

/**
 * True for a real project font path. The browser's bundled Roboto Condensed
 * face and the old firmware font sentinels are never firmware font resources.
 */
export function isProjectFontReference(value) {
  return typeof value === 'string'
    && value.trim() !== ''
    && !LEGACY_FIRMWARE_FONT_FAMILIES.has(value)
}
